<template>
  <div class="grey">
    <el-divider></el-divider>
    <el-row style="height: 10px">
      <el-col :span="12" style="text-align: left; margin-top: -10px"><el-button type="text">订单联查</el-button>&nbsp;&nbsp;<el-button v-hasPermi="['order:orderProcessing:payMoney']" type="text" @click="handlePayMoneyShow(order)">付款登记</el-button>&nbsp;&nbsp;<el-button type="text" @click="handleCancelAtDelivery(order)">货品已送回</el-button></el-col>
      <el-col :span="12" style="text-align: right; margin-top: -10px">
        <div v-if="order.canDestroy">
          <div v-if="pickingStatus === 3">
            <div v-if="order.zafterStatus === 1">
              <el-button type="text" @click="handleReturnStatus(order)">评估是否返库</el-button>
            </div>
            <div v-if="order.zafterStatus === 2">
              <div v-if="order.breturnStatus === 0">订单货品不用返店，全部<el-button v-hasPermi="['order:orderProcessing:cancel']" type="text" @click="handleReturnPickingAndOut(order)">核销后再出库</el-button></div>
              <div v-else-if="order.breturnStatus === 1">订单货品需要全部<el-button type="text" @click="handleReturnWayShow(order)">取回</el-button></div>
            </div>
            <div v-else-if="order.zafterStatus === 3">
              <div v-if="order.zreturnType === 1">已安排骑手上门取货，等待订单<el-button v-hasPermi="['order:orderProcessing:return']" type="text" @click="handleReturnArriveShow(order)">货品返店</el-button>&nbsp;&nbsp;<el-button type="text" @click="handleReturnPickingAndOut(order)">取货异常</el-button></div>
              <div v-if="order.zreturnType === 2">已安排快递上门取货，等待订单<el-button v-hasPermi="['order:orderProcessing:return']" type="text" @click="handleReturnArriveShow(order)">货品返店</el-button>&nbsp;&nbsp;<el-button type="text" @click="handleReturnPickingAndOut(order)">取货异常</el-button></div>
              <div v-if="order.zreturnType === 3">已安排其他方式取货，等待订单<el-button v-hasPermi="['order:orderProcessing:return']" type="text" @click="handleReturnArriveShow(order)">货品返店</el-button>&nbsp;&nbsp;<el-button type="text" @click="handleReturnPickingAndOut(order)">取货异常</el-button></div>
            </div>
            <div v-else-if="order.zafterStatus === 4">
              <div v-if="order.zreturnStoreType === 1">订单货品已返店，请<el-button v-hasPermi="['order:orderProcessing:cancel']" type="text" @click="handleReturnPicking(order)">核销拣货单</el-button></div>
              <div v-if="order.zreturnStoreType === 2">订单货品已返回总仓，请在<el-button v-hasPermi="['order:orderProcessing:cancel']" type="text" @click="handleReturnPicking(order)">核销拣货单</el-button>后退总仓</div>
            </div>
          </div>
          <div v-else-if="order.zafterStatus === 5">订单可以<el-button v-hasPermi="['order:orderProcessing:close']" type="text" @click="handleCloseOrder(order)">关闭</el-button></div>
          <div v-else-if="order.zafterStatus === 6">订单已取消，请<el-button v-hasPermi="['order:orderProcessing:cancel']" type="text" @click="handleReturnPicking(order)">核销拣货单</el-button></div>
        </div>
      </el-col>
    </el-row>
    <el-dialog v-if="payMoneyDialog" class="videoDialog" :close-on-click-modal="false" title="付款登记" :visible.sync="payMoneyDialog" width="450px" append-to-body>
      <el-form label-width="100px" label-position="left">
        <el-form-item label="销售渠道">
          <span v-if="payMoneyData.zplatOrder === 0">美团闪购</span>
          <span v-else-if="payMoneyData.zplatOrder === 1">京东到家</span>
          <span v-else-if="payMoneyData.zplatOrder === 2">饿了么零售</span>
          <span v-else>tops</span>
        </el-form-item>
        <el-form-item label="收单店铺">
          <span>{{ payMoneyData.sshop }}</span>
        </el-form-item>
        <el-form-item label="财务关系">
          <span>{{ payMoneyData.sfinance }}</span>
        </el-form-item>
        <el-form-item label="订单号">
          <span>{{ payMoneyData.rorder }}</span>
        </el-form-item>
        <el-form-item>
          <template slot="label"><span style="color: red">*</span>费用类型</template>
          <el-select v-model="payMoneyData.payType">
            <el-option label="线下退款" value="1">线下退款</el-option>
            <el-option label="运费" value="2">运费</el-option>
            <el-option label="其他" value="3">其他</el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <template slot="label"><span style="color: red">*</span>收付款</template>
          <el-select v-model="payMoneyData.payType">
            <el-option label="付款" value="1">付款</el-option>
            <el-option label="收款" value="2">收款</el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <template slot="label"><span style="color: red">*</span>金额</template>
          <el-input v-model="payMoneyData.payMoney" style="width: 200px" />
        </el-form-item>
        <el-form-item label="付款摘要">
          <el-input v-model="payMoneyData.payRemark" style="width: 200px" />
        </el-form-item>
      </el-form>
      <el-row type="flex" justify="end">
        <el-button type="primary" plain @click="payMoneyDialog = false">取 消</el-button>
        <el-button type="primary" :loading="refuseLoading" @click="handlePayMoneySaveAndRefund">确 认</el-button>
      </el-row>
    </el-dialog>
    <el-dialog v-if="returnWayDialog" class="videoDialog" :close-on-click-modal="false" title="选择取货方式" :visible.sync="returnWayDialog" width="500px" append-to-body>
      <div @click="returnWayOption = 1">
        <el-card shadow="hover" :class="{ 'is-selected': returnWayOption === 1, ' box-shadow': returnWayOption === 1, marginBottom10: 1 }" body-style="background-color: white;">骑手取货</el-card>
      </div>
      <div @click="returnWayOption = 2">
        <el-card shadow="hover" :class="{ 'is-selected': returnWayOption === 2, ' box-shadow': returnWayOption === 2, marginBottom10: 1 }" body-style="background-color: white;">快递上门取货</el-card>
      </div>
      <div @click="returnWayOption = 3">
        <el-card shadow="hover" :class="{ 'is-selected': returnWayOption === 2, ' box-shadow': returnWayOption === 2, marginBottom10: 1 }" body-style="background-color: white;">其他方式取货</el-card>
      </div>
      <div v-if="returnWayOption === 3">
        <el-radio-group v-model="returnWayRadio">
          <el-radio :label="1">无需付款</el-radio>
          <el-radio :label="2">需要付款</el-radio>
        </el-radio-group>
      </div>
      <el-row type="flex" justify="end">
        <el-button type="primary" plain @click="returnWayDialog = false">取 消</el-button>
        <el-button type="primary" :loading="refuseLoading" @click="handleReturnWay">确 认</el-button>
      </el-row>
    </el-dialog>
    <el-dialog v-if="returnRideDialog" class="videoDialog" :close-on-click-modal="false" title="骑手上门取货" :visible.sync="returnRideDialog" width="700px" append-to-body>
      <el-form label-width="100px" label-position="left">
        <el-row>
          <span style="color: grey">顾客信息</span>
        </el-row>
        <br />
        <el-row>
          <el-col :span="10">
            <el-form-item>
              <template slot="label">顾客姓名<span style="color: red">*</span></template>
              <el-input v-model="returnRideData.customerName" placeholder="请输入" style="width: 150px" />
            </el-form-item>
          </el-col>
          <el-col :span="14">
            <el-form-item>
              <template slot="label">手机号码<span style="color: red">*</span></template>
              <el-input v-model="returnRideData.customerPhone" placeholder="请输入" style="width: 250px" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="顾客地址">
          <el-input v-model="returnRideData.customerAddr" style="width: 525px" :disabled="true" />
        </el-form-item>
        <el-row>
          <span style="color: grey">收货门店信息</span>
        </el-row>
        <br />
        <el-form-item label="门店名称">
          <el-input v-model="returnRideData.customerAddr" style="width: 525px" :disabled="true" />
        </el-form-item>
        <el-form-item label="门店电话">
          <el-input v-model="returnRideData.customerAddr" style="width: 525px" :disabled="true" />
        </el-form-item>
        <el-form-item label="收件人地址">
          <el-input v-model="returnRideData.customerAddr" style="width: 525px" :disabled="true" />
        </el-form-item>
        <el-row>
          <el-col :span="10">
            <el-form-item label="配送平台">
              <el-select v-model="returnRideData.payType" style="width: 150px">
                <el-option label="微信" value="1">自动分配</el-option>
                <el-option label="支付宝" value="2">蜂鸟</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="14">
            <el-form-item>
              <template slot="label">发单时间<span style="color: red">*</span></template>
              <el-date-picker v-model="returnRideData.timeDate" type="datetime" placeholder="选择日期时间" style="width: 250px"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="商家备注">
          <el-input v-model="returnRideData.customerAddr" style="width: 525px" />
        </el-form-item>
      </el-form>
      <el-row type="flex" justify="end">
        <el-button type="primary" plain @click="returnRideDialog = false">取 消</el-button>
        <el-button type="primary" :loading="refuseLoading" @click="handlePayMoneySaveAndRefund">确 认</el-button>
      </el-row>
    </el-dialog>
    <el-dialog v-if="returnFastDialog" class="videoDialog" :close-on-click-modal="false" title="快递上门取货" :visible.sync="returnFastDialog" width="700px" append-to-body>
      <el-form label-width="100px" label-position="left">
        <el-row>
          <span style="color: grey">寄件人信息</span>
        </el-row>
        <br />
        <el-row>
          <el-col :span="10">
            <el-form-item label="寄件人姓名">
              <el-input v-model="returnRideData.customerName" placeholder="请输入" style="width: 150px" />
            </el-form-item>
          </el-col>
          <el-col :span="14">
            <el-form-item label="手机号码">
              <el-input v-model="returnRideData.customerPhone" placeholder="请输入" style="width: 250px" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="寄件人地址">
          <el-input v-model="returnRideData.customerAddr" style="width: 525px" :disabled="true" />
        </el-form-item>
        <el-row>
          <el-col :span="10">
            <el-form-item label="寄件类型">
              <el-input v-model="returnRideData.customerName" placeholder="请输入" style="width: 150px" />
            </el-form-item>
          </el-col>
          <el-col :span="14">
            <el-form-item label="取货时间">
              <el-input v-model="returnRideData.customerPhone" placeholder="请输入" style="width: 250px" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <span style="color: grey">收件人信息</span>
        </el-row>
        <br />
        <el-row>
          <el-col :span="10">
            <el-form-item label="收件人姓名">
              <el-input v-model="returnRideData.customerName" placeholder="请输入" style="width: 150px" :disabled="true" />
            </el-form-item>
          </el-col>
          <el-col :span="14">
            <el-form-item label="手机号码">
              <el-input v-model="returnRideData.customerPhone" placeholder="请输入" style="width: 250px" :disabled="true" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="收件人地址">
          <el-input v-model="returnRideData.customerAddr" style="width: 525px" :disabled="true" />
        </el-form-item>
      </el-form>
      <el-row type="flex" justify="end">
        <el-button type="primary" plain @click="returnRideDialog = false">取 消</el-button>
        <el-button type="primary" :loading="refuseLoading" @click="handlePayMoneySaveAndRefund">确 认</el-button>
      </el-row>
    </el-dialog>
    <el-dialog v-if="returnArrivedDialog" class="videoDialog" :close-on-click-modal="false" title="收货提示" :visible.sync="returnArrivedDialog" width="450px" append-to-body>
      <div @click="returnArrivedOption = 1">
        <el-card shadow="hover" :class="{ 'is-selected': returnWayOption === 1, ' box-shadow': returnWayOption === 1, marginBottom10: 1 }" body-style="background-color: white;">门店收到货</el-card>
      </div>
      <div @click="returnArrivedOption = 2">
        <el-card shadow="hover" :class="{ 'is-selected': returnWayOption === 2, ' box-shadow': returnWayOption === 2, marginBottom10: 1 }" body-style="background-color: white;">总仓收到</el-card>
      </div>
      <el-row type="flex" justify="end">
        <el-button type="primary" plain @click="returnArrivedDialog = false">取 消</el-button>
        <el-button type="primary" :loading="refuseLoading" @click="handleReturnArrive">确 认</el-button>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "OrderAfter",
  props: {
    order: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      payMoneyDialog: false,
      returnRideDialog: false,
      returnFastDialog: false,
      returnWayDialog: false,
      returnArrivedDialog: false,
      payMoneyData: {
        sfinance: "",
        rorder: "",
      },
      returnRideData: {},
      returnFastData: {},
      refuseLoading: false,
      returnWayRadio: 1,
      returnWayOption: 1,
      returnArrivedOption: 1,
      pickingStatus: null,
    };
  },
  mounted() {
    if (this.order.rpick) {
      let url = `${this.baseUrls.ordPicking}/selectById`;
      let params = { sid: this.order.rpick };
      this.topsAjax.get(url, params).then((res) => {
        this.pickingStatus = res.picking.zstate;
      });
    }
  },
  methods: {
    handlePayMoneyShow(order) {
      this.returnWayRadio = 1;
      this.orderInfo = order;
      this.payMoneyData = {};
      this.payMoneyData.zplatOrder = this.orderInfo.zplatOrder;
      this.payMoneyData.sshop = this.orderInfo.sshop;
      this.payMoneyData.rshop = this.orderInfo.rshop;
      this.payMoneyData.rorder = this.orderInfo.ccode;
      if (this.orderInfo.rshop !== undefined && this.orderInfo.rshop !== "") {
        this.topsAjax.get(`${this.baseUrls.shop}/getById/${this.orderInfo.rshop}`).then((response) => {
          this.payMoneyData.sfinance = response.sfinance;
          this.payMoneyData.cfinance = response.cfinance;
          this.payMoneyDialog = true;
        });
      }
    },
    handleReturnWay() {
      if (this.returnWayOption === 1) {
        this.returnRideDialog = true;
      } else if (this.returnWayOption === 2) {
        this.returnFastData = true;
      } else {
        if (this.returnWayRadio === 1) {
          this.topsAjax.post(`${baseUrls.third}/return/onWay`, { orderId: this.orderInfo.sid }).then(() => {
            this.$message.success("已安排其他方式送回");
            this.$emit("refreshPage");
          });
        } else {
          this.payMoneyData = {};
          this.payMoneyData.zplatOrder = this.orderInfo.zplatOrder;
          this.payMoneyData.sshop = this.orderInfo.sshop;
          this.payMoneyData.rshop = this.orderInfo.rshop;
          this.payMoneyData.rorder = this.orderInfo.ccode;
          if (this.orderInfo.rshop !== undefined && this.orderInfo.rshop !== "") {
            this.topsAjax.get(`${this.baseUrls.shop}/getById/${this.orderInfo.rshop}`).then((response) => {
              this.payMoneyData.sfinance = response.sfinance;
              this.payMoneyData.cfinance = response.cfinance;
              this.payMoneyDialog = true;
            });
          }
        }
      }
    },
    handleCancelAtDelivery(order) {
      this.topsAjax.post(`${this.baseUrls.order}/cancelAtDelivery`, { orderId: order.sid }).then(() => {
        this.$message.success("操作成功");
      });
    },
    handleReturnArriveShow(order) {
      this.orderInfo = order;
      this.returnArrivedDialog = true;
    },
    handleReturnArrive() {
      this.topsAjax.post(`${baseUrls.third}/return/arrived`, { orderId: this.orderInfo.sid, returnArrivedOption: this.returnArrivedOption }).then(() => {
        this.$message.success("收货成功");
        this.$emit("refreshPage");
      });
    },
    handleReturnWayShow(order) {
      this.orderInfo = order;
      this.returnWayDialog = true;
    },
    handleCloseOrder(order) {
      this.$confirm(`确认关闭订单？`, {
        type: "warning",
      }).then((_) => {
        let url = `${baseUrls.third}/close`;
        this.topsAjax.post(url, { orderId: order.sid, type: 1 }).then(() => {
          this.$message.success("关闭成功");
          this.$emit("refreshPage");
        });
      });
    },
    handlePayMoneySaveAndRefund() {
      if (this.returnWayRadio === 2) {
        this.topsAjax.post(`${baseUrls.returnPay}/return/other`, this.payMoneyData).then(() => {
          this.$message.success("已安排其他方式送回");
          this.$emit("refreshPage");
        });
      } else {
        this.topsAjax.post(`${baseUrls.returnPay}`, this.payMoneyData).then(() => {
          this.$message.success("已安排其他方式送回");
          this.$emit("refreshPage");
        });
      }
    },
    handleReturnStatus(order) {
      this.topsAjax.post(`${this.baseUrls.configRecycle}/listByOrderId`, { sorder: order.ccode }).then((response) => {
        if (response.length > 0) {
          order.breturnStatus = 1;
        } else {
          order.breturnStatus = 0;
        }
        order.zafterStatus = 2;
      });
    },
    handleReturnPicking(order) {
      this.$confirm("确认要核销选定的拣货单？", "关单提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.topsAjax.post(`${this.baseUrls.third}/cancelPicking`, { sid: order.sid }).then(() => {
          this.$message({
            message: "操作成功",
            type: "success",
          });
        });
      });
    },
    handleReturnPickingAndOut(order) {
      let str = "";
      if (this.pickingStatus === 1) {
        str = "确认要删除选定的拣货单？";
      } else if (this.pickingStatus === 2) {
        str = "确认要取消选定的拣货单？";
      } else if (this.pickingStatus === 3) {
        str = "确认要核销选定的拣货单？";
      }
      this.$confirm(str, "关单提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.topsAjax.post(`${this.baseUrls.third}/cancelPickingAndOut`, { sid: order.sid }).then(() => {
          this.$message({
            message: "操作成功",
            type: "success",
          });
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.el-divider--horizontal {
  margin: 5px 0 !important;
}
</style>
